var React = require('react');

function Tag (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_86","data-name":"Path 86","d":"M80.629-116.351a37.972,37.972,0,0,1,8.456-2.226s-10.883,5.276-7.5,14.571c3.849,10.576,20.436,5.579,28.978-.568-16.007,8.109-24.468,5.032-26.717-1.145,7.694,10.119,23.866-.667,34.327-4.475,15.035-5.472,27.812.1,32.213,12.188,6.11,16.788-5.263,31.628-15.175,35.236,0,0,4.61-4.311,2.867-9.1-.994-2.731-4.117-5.841-11.42-3.182-3.672,1.337-15.7,8.038-28.454,12.678-24.452,8.9-37.325-2.249-41.524-13.786C52.216-88.43,55.549-107.223,80.629-116.351Zm49.013,7.265s9.854.812,14.752,14.271c4.671,12.834-2.436,23.338-2.765,23.814l-.009.013.232-.244c5.3-5.671,9.224-14.823,5.653-25.208l-.162-.459C144.512-104.673,137.9-109,129.641-109.087Z","transform":"translate(-55.006 118.577)","fill":"#f30000","fillRule":"evenodd"}));
}

Tag.defaultProps = {"width":"97.101","height":"59.427","viewBox":"0 0 97.101 59.427"};

module.exports = Tag;

Tag.default = Tag;
